import { MarkerF } from '@react-google-maps/api';
import React from 'react';
import Address from '../../models/Address';
import AddressMapResult from '../../models/AddressMapResult';
import { asFloat } from '../../services/ValueChecker';
import { getMarkerLabel } from './multiMapUtils';

interface MultiMapMarkersProps {
  addresses: Address[] | AddressMapResult[];
}

const MultiMapMarkers: React.FC<MultiMapMarkersProps> = ({ addresses }) => (
  <>
    {addresses.map((address, index) => {
      const lat = asFloat(address.latitude);
      const lng = asFloat(address.longitude);
      const label = getMarkerLabel(address, index);

      return (
        <React.Fragment key={address.id || address.placeId}>
          <MarkerF
            position={{ lat, lng }}
            title={address.fullAddress}
            label={{
              text: label,
              color: 'white',
              fontWeight: 'bold',
            }}
            icon={{
              url: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
            }}
          />

          {'nearbyPlaces' in address &&
            (address as AddressMapResult).nearbyPlaces?.map((place) => (
              <MarkerF
                key={place.placeId}
                position={{
                  lat: asFloat(place.coordinates.latitude),
                  lng: asFloat(place.coordinates.longitude),
                }}
                title={place.name}
                label={{
                  text: place.name,
                  color: 'black',
                  fontWeight: 'bold',
                }}
                icon={{
                  url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
                }}
              />
            ))}
        </React.Fragment>
      );
    })}
  </>
);

export default MultiMapMarkers;
